import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const [location, setLocation] = useState('');
  const [propertyType, setPropertyType] = useState('');
  const [listingType, setListingType] = useState('buy');
  const navigate = useNavigate();

  const handleSearch = () => {
    const params = new URLSearchParams();
    if (location) params.set('location', location);
    if (propertyType) params.set('type_prop', propertyType);
    if (listingType === 'rent') params.set('type', 'rent');
    else params.set('type', 'sale');
    navigate(`/listings?${params.toString()}`);
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4be671b0492f108c950badfbcd09b411.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-8 text-center pt-24 pb-16">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-white/90 text-xs font-medium mb-6">
          <i className="ri-verified-badge-line text-amber-400"></i>
          10,000+ Verified Properties Nationwide
        </div>

        <h1 className="text-5xl md:text-7xl font-black text-white leading-tight mb-4">
          Discover Your
          <span className="block text-amber-400">Dream Home</span>
        </h1>
        <p className="text-white/75 text-lg md:text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
          Explore premium properties across the world's most sought-after locations. Your perfect home is just a search away.
        </p>

        {/* Search Card */}
        <div className="bg-white/95 backdrop-blur-md rounded-2xl p-2 max-w-3xl mx-auto">
          {/* Tabs */}
          <div className="flex gap-1 mb-3 px-1 pt-1">
            {['buy', 'rent'].map(tab => (
              <button
                key={tab}
                onClick={() => setListingType(tab)}
                className={`px-5 py-1.5 rounded-full text-sm font-semibold transition-colors cursor-pointer capitalize whitespace-nowrap ${
                  listingType === tab
                    ? 'bg-amber-500 text-white'
                    : 'text-stone-500 hover:text-stone-700'
                }`}
              >
                {tab === 'buy' ? 'Buy' : 'Rent'}
              </button>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-2 px-1 pb-1">
            {/* Location */}
            <div className="flex-1 flex items-center gap-2 bg-stone-50 rounded-xl px-4 py-3">
              <span className="w-4 h-4 flex items-center justify-center text-amber-500">
                <i className="ri-map-pin-line text-base"></i>
              </span>
              <input
                type="text"
                value={location}
                onChange={e => setLocation(e.target.value)}
                placeholder="City, neighborhood, or address"
                className="flex-1 bg-transparent text-sm text-stone-700 placeholder-stone-400 focus:outline-none"
              />
            </div>

            {/* Property Type */}
            <div className="flex items-center gap-2 bg-stone-50 rounded-xl px-4 py-3 min-w-[160px]">
              <span className="w-4 h-4 flex items-center justify-center text-amber-500">
                <i className="ri-home-line text-base"></i>
              </span>
              <select
                value={propertyType}
                onChange={e => setPropertyType(e.target.value)}
                className="flex-1 bg-transparent text-sm text-stone-700 focus:outline-none cursor-pointer"
              >
                <option value="">Property Type</option>
                <option value="House">House</option>
                <option value="Apartment">Apartment</option>
                <option value="Villa">Villa</option>
                <option value="Studio">Studio</option>
                <option value="Penthouse">Penthouse</option>
                <option value="Townhouse">Townhouse</option>
              </select>
            </div>

            {/* Search Button */}
            <button
              onClick={handleSearch}
              className="px-8 py-3 bg-amber-500 hover:bg-amber-600 text-white font-bold rounded-xl transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <i className="ri-search-line"></i>
              Search
            </button>
          </div>
        </div>

        {/* Stats */}
        <div className="flex flex-wrap justify-center gap-8 mt-10">
          {[
            { value: '10K+', label: 'Properties', icon: 'ri-building-line' },
            { value: '500+', label: 'Expert Agents', icon: 'ri-user-star-line' },
            { value: '98%', label: 'Satisfaction', icon: 'ri-thumb-up-line' },
            { value: '50K+', label: 'Happy Clients', icon: 'ri-heart-line' },
          ].map(stat => (
            <div key={stat.label} className="text-center">
              <div className="flex items-center justify-center gap-1.5 text-white mb-0.5">
                <i className={`${stat.icon} text-amber-400`}></i>
                <span className="text-2xl font-black">{stat.value}</span>
              </div>
              <p className="text-white/60 text-xs">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-white/50 animate-bounce">
        <i className="ri-arrow-down-line text-lg"></i>
      </div>
    </section>
  );
};

export default HeroSection;
